import { render, staticRenderFns } from "./structure-tree.vue?vue&type=template&id=737c0335&scoped=true&"
import script from "./structure-tree.vue?vue&type=script&lang=ts&"
export * from "./structure-tree.vue?vue&type=script&lang=ts&"
import style0 from "./structure-tree.vue?vue&type=style&index=0&id=737c0335&lang=less&scoped=true&"
import style1 from "./structure-tree.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737c0335",
  null
  
)

export default component.exports